import s from './GuestSection.module.scss';

export default function GuestSection({ heading, children }) {
  return (
    <div className={s.wrapper}>
      <h3 className={s.heading}>{heading}</h3>
      <div className={s.body}>{children}</div>
    </div>
  );
}
